// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import App from './App'
// import router from './router'
/*
 * Form Components
 */
import vueFormly from 'vue-formly'
import vueFormlyBootstrap from 'vue-formly-bootstrap'
import Draggable from 'vuedraggable'
import MaskedInput from 'vue-masked-input'
import FormlyFormFlex from '@/components/form/FormlyFormFlex'
import ImageToggle from '@/components/form/elements/ImageToggle'
import MaskedInputField from '@/components/form/elements/MaskedInputField'
import SubmitButton from '@/components/form/elements/SubmitButton'
import ListRepeater from '@/components/form/elements/ListRepeater'
import MultiSelect from '@/components/form/elements/MultiSelect'
import Select from '@/components/form/elements/Select'
import Datepicker from '@/components/form/elements/Datepicker'

import DynamicForm from '@/widgets/DynamicForm'
import TaskCarousel from '@/widgets/TaskCarousel'
import NotificationIndicator from '@/widgets/Notifications'
import ApprovalIndicator from '@/widgets/ApprovalIndicator'
import ProgressIndicator from '@/widgets/ProgressIndicator'

import * as VueDeepSet from 'vue-deepset'
/*
 * Chart Components
 */
import TimeLine from '@/components/charts/TimeLine'
import StackedBarTier from '@/components/charts/StackedBarTier'
import DetailTable from '@/components/charts/DetailTable'
import GaugeTier from '@/components/charts/GaugeTier'
import HeatMap from '@/components/charts/HeatMap'
import AttachCustomer from '@/widgets/AttachCustomer'
import CustomerSearch from '@/widgets/CustomerSearch'
import MomentPlugin from '@/plugins/moment'

/*
 * Query Components
 */
import QueryBuilder from '@/components/search/QueryBuilder'

/*
 * Widgets
 */
import SavedSearches from '@/widgets/SavedSearches'
import ApprovalQueue from '@/widgets/ApprovalQueue'

Vue.use(VueDeepSet)
Vue.use(vueFormly)
Vue.use(vueFormlyBootstrap)
Vue.use(MomentPlugin)

Vue.component('FormlyFormFlex', FormlyFormFlex)
Vue.$formly.addType('listedit', ListRepeater)
Vue.$formly.addType('imagetoggle', ImageToggle)
Vue.$formly.addType('maskedinput', MaskedInputField)
Vue.$formly.addType('submit', SubmitButton)
Vue.$formly.addType('multiselect', MultiSelect)
Vue.$formly.addType('select', Select)
Vue.$formly.addType('datepicker', Datepicker)
Vue.$formly.addValidationMessage('required', 'This field is required')

Vue.config.productionTip = false

Vue.component('DynamicForm', DynamicForm)
Vue.component('Draggable', Draggable)
Vue.component('MaskedInput', MaskedInput)
Vue.component('GaugeTier', GaugeTier)
Vue.component('TimeLine', TimeLine)
Vue.component('StackedBarTier', StackedBarTier)
Vue.component('DetailTable', DetailTable)
Vue.component('HeatMap', HeatMap)
Vue.component('AttachCustomer', AttachCustomer)
Vue.component('ApprovalQueue', ApprovalQueue)

Vue.component('TaskCarousel', TaskCarousel)
Vue.component('NotificationIndicator', NotificationIndicator)
Vue.component('ApprovalIndicator', ApprovalIndicator)
Vue.component('ProgressIndicator', ProgressIndicator)

Vue.component('QueryBuilder', QueryBuilder)
Vue.component('CustomerSearch', CustomerSearch)
Vue.component('SavedSearches', SavedSearches)
/* eslint-disable no-new */

// new Vue({
//     el: '#dynamic-form',
//     components: {dynamicForm: dynamicForm},
//     template: '<dynamic-form :id="id" :formapi="formPath"/>',
//     data: {
//         id: 12342,
//         formPath: 'http://kitt.local.it/partner/customercontact/load'
//     }
// })

window.Vue = Vue



// WEBPACK FOOTER //
// ./src/main.js